<template>
    <transition-group tag="div" name="notification-transition" class="notifications">
        <notification v-for="notification in notifications" :notification="notification" @close-notification="removeNotification" :key="notification.id" >
        </notification>
    </transition-group>
</template>


<script>
// http://forum.vuejs.org/topic/2122/resusable-global-notification-popups-with-vue-the-store-pattern-foundation-and-animate-css/4
import Notification from './Notification.vue';

export default {
    components: { Notification },
    vuex: {
        getters: {
            notifications: state => state.notifications.all.slice(0, 5).reverse(),
        },
        actions: {
            removeNotification: ({dispatch}, notification) => dispatch('REMOVE_NOTIFICATION', notification)
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

    .notifications {
        position: fixed;
        right: 1.5em;
        top: 1.5em;
        width: 350px;
        z-index: $z-index-notification;

        @media #{$media-mobile} {
            right: 0;
            max-width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// Notifications.vue?5484c373